import { graphql } from "react-relay";

export const QUERY = graphql`
	query messageDefinitions_MessageDefinitionsQuery($filterByTextOpt: String) {
		...messageDefinitionsTable_QueryFragment @arguments(filterByTextOpt: $filterByTextOpt)
	}
`;
